module.exports = __webpack_public_path__ + "img/贡献.ce2dfb08.png";